import { createAction } from 'redux-act';

export const setTransferTradesModalVisible = createAction('SET_TRANSFER_TRADES_MODAL_VISIBLE');
export const setTransferTradesForm = createAction('SET_TRANSFER_TRADES_FORM');
export const closeTransferTradesForm = createAction('CLOSE_TRANSFER_TRADES_FORM');
export const setTransferTradesNotificationIds = createAction('SET_TRANSFER_TRADES_NOTIFICATION_IDS');
export const setTransferTradesFieldsLockedByNotification = createAction(
  'SET_TRANSFER_TRADES_FIELDS_LOCKED_BY_NOTIFICATION'
);